// removed by extract-text-webpack-plugin
module.exports = {"popupWrapper":"Popup__popupWrapper___1ef_V"};


//////////////////
// WEBPACK FOOTER
// ./src/common/Popup/Popup.scss
// module id = 731
// module chunks = 0